<script setup>
import SInfoModifiable from '@/components/global/s-info-modifiable.vue'
import SBorneHorairePicker from '@/components/global/s-borne-horaire-picker.vue'

defineEmits(['update'])
</script>

<template>
  <s-info-modifiable
    :disabled="!editable"
    class="mb-6"
    titre="Heure de debut de service"
    @validateUpdate="handleUpdate"
  >
    <template #contentToDisplay>
      <span v-if="plageHoraire.heureDebut || plageHoraire.heureFin">
        {{ plageHoraire.heureDebut.heure }}:{{ plageHoraire.heureDebut.minute }} - {{ plageHoraire.heureFin.heure }}:{{
          plageHoraire.heureFin.minute
        }}
      </span>
      <span v-else> Aucun horaire configuré </span>
    </template>
    <template #champ>
      <v-row>
        <v-col cols="12" sm="6">
          <s-borne-horaire-picker
            v-model="plageHoraire.heureDebut"
            label="Début"
            :borne-max="plageHoraire.heureFin"
            required
          />
        </v-col>
        <v-col cols="12" sm="6">
          <s-borne-horaire-picker
            v-model="plageHoraire.heureFin"
            label="Fin"
            :borne-min="plageHoraire.heureDebut"
            required
          />
        </v-col>
      </v-row>
    </template>
  </s-info-modifiable>
</template>
<script>
export default {
  name: 's-info-plage-horaire',
  data() {
    return {
      plageHoraire: undefined,
    }
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleUpdate() {
      this.$emit('update')
    },
  },
  created() {
    if (this.value) {
      this.plageHoraire = this.value
    }
  },
}
</script>
